module.exports = __webpack_public_path__ + "img/about-your-health.174bddbc.png";